export enum NameWritingSteps {
	Students = 1,
	PrintSettings,
	Preview,
	Final,
}